<template>
  <div class="flex space-x-1 items-center cursor-pointer">

    <DefineTemplate>
      <div class="ml-5 overflow-scroll">
        <cart-contents v-if="step == 'cart'" @checkout="() => step = 'form'" @close="() => open=false"/>
        <cart-checkout v-if="step == 'form'" @back="() => step='cart'" @close="() => open=false"/>
      </div>
    </DefineTemplate>

    <UModal v-if="isDesktop" v-model:open="open">
      <div class="flex items-center font-medium space-x-2">
        <div>Cart</div>
        <cart-icon/>
      </div>

      <template #content>
        <ReuseTemplate />
      </template>


    </UModal>

    <UDrawer v-model:open="open" direction="bottom" :handle="false" v-else>
      <div class="flex items-center">
        <cart-icon/>
      </div>
      <template #content>
        <div class="ml-5 overflow-scroll">
          <ReuseTemplate />
        </div>
      </template>
    </UDrawer>
  </div>

</template>

<script lang="ts" setup>
import { createReusableTemplate } from '@vueuse/core'
const [DefineTemplate, ReuseTemplate] = createReusableTemplate()

import {useMediaQuery} from "@vueuse/core/index";

const step = ref<'cart' | 'form'>('cart')
const isDesktop = useMediaQuery('(min-width: 768px)')
const open = ref<boolean>(false)

watch(
    open,
    (newVal, oldVal) => {
      if (oldVal && !newVal) {
        step.value = 'cart'
      }
    }
)


</script>